module.exports = __webpack_public_path__ + "static/media/iterate.6d06223a.svg";